/* unplugin-vue-components disabled */import { render } from "./SettingsPaymentMethods.vue?vue&type=template&id=28fc78e3&ts=true"
import script from "./SettingsPaymentMethods.vue?vue&type=script&lang=ts"
export * from "./SettingsPaymentMethods.vue?vue&type=script&lang=ts"

import "./SettingsPaymentMethods.vue?vue&type=style&index=0&id=28fc78e3&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__